module.exports = __webpack_public_path__ + "6c608144e9340537e90788a887ef1ce4.png";